import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getUsers, deleteUser, changeStatusUser } from "../../../../api/user";
import { Button, Tooltip, Switch, FormControlLabel, TextField } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import { Autorenew as FilterOffIcon } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import {
  canEditUsersModule,
  isReadOnlyConsultor,
} from "../../../../_helpers/backofficePermissions";
import FiltersCard from "../../../components/filters/Filter";
import { getUserTypes } from "../../../../api/userType";
import { SERVER_URL } from "../../../../api";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";

function isDocente(user) {
  return user?.role === "docente" || user?.esDocente === true;
}

function getData(users, types) {
  let data = [];
  for (let i = 0; i < users.length; ++i) {
    if (isDocente(users[i])) {
      const elem = {};
      elem.name = users[i].fullName;
      elem.apellido1 = users[i].apellido1;
      elem.apellido2 = users[i].apellido2;
      elem.rrss = users[i].rrss;
      // En el modelo existen ambos campos: `dni` y `nif`. Para docentes tratamos ambos como NIF.
      elem.dni = users[i].dni || users[i].nif;
      elem.email = users[i].email;
      elem.imageURL = users[i].imageURL;
      elem.createdAt = users[i].createdAt;
      elem.id = users[i]._id;
      elem.active = users[i].active;
      data = data.concat(elem);
    }
  }
  return data;
}

const initialFilters = {
  active: false,
  asociado: false,
};

export default function DocentesPage() {
  const [data, setData] = useState([]);
  const [userId, setUserId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [users, setUsers] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [filterOptions, setFilterOptions] = useState(initialFilters);
  // Estado para el campo de búsqueda
  const [searchText, setSearchText] = useState(() => {
    const saved = localStorage.getItem('docentesPage_searchText');
    return saved || '';
  });
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [previewImages, setPreviewImages] = useState(null);

  function buttonFormatter(cell) {
    // Buscar en los datos transformados que se muestran en la tabla (docentes: role docente o esDocente)
    const transformedData = getData(filteredData, userTypes);
    const elem = transformedData.find((item) => item.id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-docente/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {(canEditUsersModule(user?.role) && !isReadOnlyConsultor(user?.role)) && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setUserId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setUserId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }
  function imageFormatter(imageURL) {
    return imageURL ? (
      <img
        src={SERVER_URL + "/" + imageURL}
        alt="artwork"
        style={{ width: "100px", cursor: "zoom-in" }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setPreviewImages(imageURL);
          setOpenPreviewDialog(1);
        }}
      />
    ) : (
      <div />
    );
  }

  const columns = [
    { dataField: "imageURL", text: "Foto", formatter: imageFormatter },
    { dataField: "name", text: "Nombre", sort: true },
    { dataField: "apellido1", text: "Apellido 1", sort: true },
    { dataField: "apellido2", text: "Apellido 2", sort: true },
    { dataField: "dni", text: "DNI", sort: true },
    { dataField: "email", text: "email", sort: true },
    { dataField: "rrss", text: "Redes Sociales", sort: true },
    {
      dataField: "createdAt",
      text: "Fecha alta",
      sort: true,
      formatter: dateFormatter,
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getUserTypes().then((res) => setUserTypes(res.data));
    getUsers()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setFilteredData(res.data);
          setUsers(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get useristrators.",
        });
      });
  }, [refresh]);

  const handleSearch = async () => {
    if (!data.length) return;
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.active) filter = filter && item.active;
        if (filterOptions.asociado) filter = filter && item.asociado;
        if (filter) return item;
        return false;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setSearchText('');
    localStorage.removeItem('docentesPage_searchText');
    localStorage.removeItem('docentesPage_currentPage');
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <div style={{ padding: "15px 0 0 0" }}>
        {/* Primera fila: Campo de búsqueda */}
        <div className="row align-items-end">
          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="search"
              label="Buscar"
              placeholder="Buscar en todos los campos..."
              value={searchText}
              onChange={(e) => {
                const value = e.target.value;
                setSearchText(value);
                if (value.trim()) {
                  localStorage.setItem('docentesPage_searchText', value);
                } else {
                  localStorage.removeItem('docentesPage_searchText');
                }
              }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>
        </div>
        {/* Switches y botones de acción en la misma línea */}
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ marginTop: "10px", marginBottom: "10px", gap: "15px" }}>
              {/* Switches a la izquierda */}
              <div className="d-flex align-items-center flex-wrap" style={{ gap: "30px" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={filterOptions.active}
                      onChange={() =>
                        setFilterOptions({
                          ...filterOptions,
                          active: !filterOptions.active,
                        })
                      }
                      name="checkActive"
                      style={{ color: "#f3691a" }}
                    />
                  }
                  label={filterOptions.active ? "Solo activos" : "Todos (activos/inactivos)"}
                  style={{ margin: 0 }}
                />
              </div>
              {/* Botones a la derecha */}
              <div className="d-flex">
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  style={{ 
                    minWidth: "120px",
                    backgroundColor: "#f3691a",
                    color: "#fff",
                    marginRight: "10px"
                  }}
                >
                  Buscar
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  startIcon={<FilterOffIcon />}
                  style={{ 
                    minWidth: "120px",
                    borderColor: "#f3691a",
                    color: "#f3691a"
                  }}
                >
                  Limpiar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Usuarios list">
          <CardHeaderToolbar>
            <Button
              variant="contained"
              onClick={() => history.push("/edit-docente")}
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/* Filtros siempre visibles con mejor diseño */}
          <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
            <CardBody style={{ padding: "15px 20px" }}>
              {renderFiltersContent()}
            </CardBody>
          </Card>

          <Table 
            data={getData(filteredData, userTypes)} 
            columns={columns} 
            pageKey="docentesPage"
            searchText={searchText}
            onSearchChange={(value) => {
              setSearchText(value);
              if (value.trim()) {
                localStorage.setItem('docentesPage_searchText', value);
              } else {
                localStorage.removeItem('docentesPage_searchText');
              }
            }}
            defaultSorted={[{ dataField: 'createdAt', order: 'desc' }]}
          />

          <ConfirmDialog
            title={`Are you sure you want to ${
              userId?.active ? "disable" : "enable"
            } this user?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              if (!userId || !userId.id) {
                alertError({
                  error: new Error("User ID not found"),
                  customMessage: "Could not find user ID. Please try again.",
                });
                setOpenConfirmDialog(null);
                return;
              }
              changeStatusUser(userId.id, !userId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${userId?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `User ${
                        userId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      userId?.active ? "disable" : "enable"
                    } user.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this user?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteUser(userId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "User removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove user.",
                  });
                });
            }}
          />
          <PreviewDialog
            title={"Preview"}
            open={openPreviewDialog === 1}
            setOpen={setOpenPreviewDialog}
            file={previewImages}
            src={previewImages ? SERVER_URL + "/" + previewImages : undefined}
          />
        </CardBody>
      </Card>
    </>
  );
}
